import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '@/pages/Login';
import Layout from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

const Dashboard = lazy(() => import('@/pages/Dashboard'));
const Players = lazy(() => import('@/pages/Players'));
const Tournaments = lazy(() => import('@/pages/Tournaments'));
const Schedules = lazy(() => import('@/pages/Schedules'));
const Registrations = lazy(() => import('@/pages/Registrations'));
const Teams = lazy(() => import('@/pages/Teams'));
const VerifyQR = lazy(() => import('@/pages/VerifyQR'));
const Admins = lazy(() => import('@/pages/Admins'));
const CompetitionSystems = lazy(() => import('@/pages/CompetitionSystems'));
const AuditLogs = lazy(() => import('@/pages/AuditLogs'));
const PublicTournamentRegistrants = lazy(() => import('@/pages/PublicTournamentRegistrants'));
const PublicCategoryBracket = lazy(() => import('@/pages/PublicCategoryBracket'));
const CategoryBracket = lazy(() => import('@/pages/CategoryBracket'));

const PageFallback = () => <div className="flex items-center justify-center min-h-[50vh] text-slate-500">Memuat...</div>;

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/public/tournaments/:tournamentId" element={<PublicTournamentRegistrants />} />
            <Route
              path="/public/tournaments/:tournamentId/categories/:categoryId/bracket"
              element={<PublicCategoryBracket />}
            />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/players" element={<ProtectedRoute><Players /></ProtectedRoute>} />
            <Route path="/tournaments" element={<ProtectedRoute><Tournaments /></ProtectedRoute>} />
            <Route
              path="/tournaments/:tournamentId/categories/:categoryId/bracket"
              element={<ProtectedRoute><CategoryBracket /></ProtectedRoute>}
            />
            <Route path="/schedules" element={<ProtectedRoute><Schedules /></ProtectedRoute>} />
            <Route path="/registrations" element={<ProtectedRoute><Registrations /></ProtectedRoute>} />
            <Route path="/teams" element={<ProtectedRoute><Teams /></ProtectedRoute>} />
            <Route path="/verify" element={<ProtectedRoute><VerifyQR /></ProtectedRoute>} />
            <Route path="/admins" element={<ProtectedRoute><Admins /></ProtectedRoute>} />
            <Route path="/competition-systems" element={<ProtectedRoute><CompetitionSystems /></ProtectedRoute>} />
            <Route path="/audit-logs" element={<ProtectedRoute><AuditLogs /></ProtectedRoute>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;